import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetTeamMemberDocumentDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/TeamMemberDocument/GetDetail?` + params, null);

export const GetTeamMemberDocumentList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/TeamMemberDocument/GetList?` + params, null);

export const CreateTeamMemberDocument = (data: any) =>
  POST_ENC(`${BASE_URL}/api/TeamMemberDocument/Create`, data, true);

export const UpdateTeamMemberDocument = (data: any) =>
  POST_ENC(`${BASE_URL}/api/TeamMemberDocument/Update`, data, true);

export const DeleteTeamMemberDocument = (data: any) =>
  POST_ENC(`${BASE_URL}/api/TeamMemberDocument/Delete`, data);
